<template>
  <div class="page-traffic">
    <app-page-box title="流量概况">
      <app-overview-bar>
        <app-overview-bar-item label="最近7天流量" tip="截止当前时间7天内产生的流量，用户每打开一个页面被记录一次，用户多次打开同一页面，浏览量值累计" :value="stats.traffic7DaysCount"></app-overview-bar-item>
        <app-overview-bar-item label="最近30天流量" tip="截止当前时间30天内产生的流量，用户每打开一个页面被记录一次，用户多次打开同一页面，浏览量值累计" :value="stats.traffic30DaysCount"></app-overview-bar-item>
        <app-overview-bar-item label="总流量" tip="截止当前时间账户推广产生的总流量，用户每打开一个页面被记录一次，用户多次打开同一页面，浏览量值累计" :value="stats.trafficTotalCount"></app-overview-bar-item>
      </app-overview-bar>
    </app-page-box>
    <app-page-box title="流量趋势">
      <div class="page-traffic__chart-filter">
        <el-button-group>
          <el-button :type="days === 0 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(0)">至今</el-button>
          <el-button :type="days === 30 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(30)">最近30天</el-button>
          <el-button :type="days === 183 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(183)">最近半年</el-button>
        </el-button-group>
        <div class="page-traffic__chart-date-picker">
          <span>自定义</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="mini"
            style="width: 245px;"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
            @change="handleDatePickerChange"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <app-line-chart :chart-data="chartData"></app-line-chart>
    </app-page-box>
    <app-page-box title="流量明细">
      <el-table size="mini" :data="detail.list">
        <el-table-column prop="accessTime" :formatter="formatAccessTime" label="时间"></el-table-column>
        <el-table-column prop="source" :formatter="formatSource" label="来源"></el-table-column>
        <!-- <el-table-column prop="region" label="地域"></el-table-column> -->
        <el-table-column prop="url" label="URL"></el-table-column>
      </el-table>
      <template v-if="detail.total > limit">
        <el-pagination :total="detail.total" @current-change="handlePageChange" layout="prev, pager, next" background></el-pagination>
      </template>
    </app-page-box>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'
import AppLineChart from '@/components/AppLineChart'
import AppOverviewBar, { AppOverviewBarItem } from '@/components/AppOverviewBar'
import searchEnginesMap from '@/assets/maps/searchEngines'
import { getDateRange, getTimestamp } from '@/utils'

export default {
  name: 'PageTraffic',
  components: {
    AppPageBox,
    AppLineChart,
    AppOverviewBar,
    AppOverviewBarItem
  },

  data () {
    return {
      days: 0,
      dateRange: [],
      offset: 0,
      limit: 10
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },
    stats () {
      return this.$store.state.traffic.stats
    },
    chartData () {
      return this.$store.state.traffic.chartData
    },
    detail () {
      return this.$store.state.traffic.detail
    }
  },

  created () {
    this.setDateRange(0)
    this.getStats()
    this.getChartData()
    this.getDetails()
  },

  methods: {
    getStats () {
      this.$store.dispatch('getTrafficStats', {
        params: { userId: this.user.id }
      })
    },

    getChartData () {
      this.$store.dispatch('getTrafficChartData', {
        params: { userId: this.user.id },
        query: {
          fromTime: getTimestamp(this.dateRange[0], 's'),
          toTime: getTimestamp(this.dateRange[1], 's')
        }
      })
    },

    getDetails () {
      this.$store.dispatch('getTrafficDetail', {
        params: { userId: this.user.id },
        query: {
          offset: this.offset * this.limit,
          limit: this.limit
        }
      })
    },

    setDateRange (days) {
      let range = null

      if (days) {
        range = getDateRange(days)
      } else {
        range = { startTime: new Date(2018, 0, 1), endTime: new Date() }
      }

      this.dateRange = [ range.startTime.toISOString(), range.endTime.toISOString() ]
      this.days = days
    },

    formatAccessTime (row, column, cellValue, index) {
      const { formatDate } = this.$options.filters
      return formatDate(cellValue, 'YYYY-MM-DD')
    },

    formatSource (row, column, cellValue, index) {
      return searchEnginesMap.getLabelById(cellValue) || '-'
    },

    handleDateRangeChange (days) {
      this.setDateRange(days)
      this.getChartData()
    },

    handleDatePickerChange () {
      this.days = null
      this.getChartData()
    },

    handlePageChange (page) {
      this.offset = --page
      this.getDetails()
    }
  }
}
</script>

<style lang="scss">
.page-traffic {
  .el-pagination {
    margin-top: 15px;
    text-align: right;
  }

  &__chart-filter {
    text-align: right;
  }

  &__chart-date-picker {
    display: inline-block;
    margin-left: 30px;
  }
}
</style>
